import { connect } from 'react-redux';

import ComponentMedia from '../components/ComponentMedia';
import {
  getImageSignedURL,
  setActiveImage,
} from '../../../../../state/modules/media/actions';
import Format from '../../../../../lib/Format';

const mapStateToProps = (state, ownProps) => {
  const image = ownProps?.data?.media ?? null;
  const size = 600;

  const imagePath = Format.buildImagePath('crop', size, size, image);

  const imageUrl = state.media.getIn(['images', imagePath]) ?? null;

  return {
    size: size,
    imagePath: imagePath,
    imageUrl: imageUrl,
    image,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSignedUrl: (path, cb) => {
      dispatch(getImageSignedURL(path, cb));
    },
    setActiveImage: (imageUrl, imagePath) => {
      dispatch(setActiveImage(imageUrl, imagePath));
    },
  };
};

const ComponentMediaContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ComponentMedia);

export default ComponentMediaContainer;
